const getSelectedOption = (options) => {
  if (!Array.isArray(options)) { throw new TypeError('Parametro no es un array') }
  if (options.length === 0) {
    throw new RangeError('Array sin elementos')
  }

  return options.find(
    option => option.selected
  )
}

const getSelectedOptionId = (options) => {
  const selectedOption = getSelectedOption(options)
  return selectedOption !== undefined ? selectedOption.id : null
}

export { getSelectedOption, getSelectedOptionId }



// WEBPACK FOOTER //
// ./src/app/shared/utils/Option.js